module.exports = __webpack_public_path__ + "assets/img/5_1380_big.399cc64f.jpg";